import { FC } from 'react';
import * as Styled from './BasketButton.styled';
import { Icon } from '@maverick/ui';
import { useTheme } from 'styled-components';
import { GaEvent } from '@maverick/utils';
import { Helmet } from 'react-helmet';
import { AppOperations, RootState } from '@maverick/store';
import { useDispatch, useSelector } from 'react-redux';

export const BasketButton: FC = () => {
    const { basket } = useSelector((state: RootState) => state.checkout);
    const { restaurant } = useSelector((state: RootState) => state.location);

    const dispatch = useDispatch();
    const setShowSummary = (showSummary: boolean) => dispatch(AppOperations.setShowSummary(showSummary));

    const { orderUi } = useTheme();
    const basketBadge = !!basket?.products.length;
    const redirectUrl = restaurant && restaurant.slug ? `/menu/${restaurant.slug}` : '';

    const handleClick = () => {
        const productCount = basket?.products.length || 0;
        GaTopNavigationEvent('Cart');
        if (productCount > 0) {
            setShowSummary(true);
        }
    };

    const GaTopNavigationEvent = (label: string) => {
        const helmetState = Helmet.peek();
        const pageTitle = helmetState?.title || document.title;
        GaEvent.BasketTopNavigation(label, basket ?? null, [], restaurant?.brand ?? 'not-set', pageTitle);
    };

    const productCount = basket?.products.length;
    const ariaLabel = `Basket${productCount ? ` ${productCount} ${productCount === 1 ? 'item' : 'items'}` : ''}`;

    return (
        <Styled.BasketButton onClick={handleClick} href={`/order${redirectUrl}`} aria-label={ariaLabel}>
            <Styled.Icon data-testid='basket-icon'>
                <Icon icon={orderUi.icons.iconBasketHeader} customSize />
                {basketBadge && <Styled.BasketBadge data-testid='basket-badge'>{productCount}</Styled.BasketBadge>}
            </Styled.Icon>
        </Styled.BasketButton>
    );
};
